import { PageFrame } from "../../components/page_frame";
import { ForecastTrackingContainer } from "./container";

export default function ForecastTrackingPage() {
  return (
    <PageFrame>
      <ForecastTrackingContainer />
    </PageFrame>
  );
}
